import { Asset } from 'expo-asset';

import type { CityCardImageProps } from './city-card-image.types';

import css from './card-image.module.css';

/**
 * Web /cities card photo: a plain <img>, not expo-image — same reasoning as
 * card-image.web.tsx. A raw <img> ships in the static HTML, so the preload
 * scanner finds the first row and `loading="lazy"` applies to the rest.
 *
 * Cards are a fixed 220x140 CSS px, so the srcSet is just 1x/2x: standard
 * screens fetch the ~10KB 220px file, retina the ~35KB 440px one.
 */
export function CityCardImage({ image, imageSm, alt, eager = false }: CityCardImageProps) {
  const uri = Asset.fromModule(image).uri;
  const smUri = Asset.fromModule(imageSm).uri;
  return (
    <img
      src={uri}
      srcSet={`${smUri} 220w, ${uri} 440w`}
      sizes="220px"
      width={220}
      height={140}
      alt={alt}
      className={css.img}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'auto'}
      decoding="async"
    />
  );
}
